import { choiceCard } from './choice-card.ts';
import { infoCard } from './info-card.ts';
import { openTabTool } from './open-tab.ts';
import { practiceQuestions } from './practice-questions.ts';
import { remember, saveWord } from './remember.ts';
import { speakingTask } from './speaking-task.ts';
import { type FunctionDeclaration, type ToolSpec, toFunctionDeclaration } from './types.ts';

// Adding a capability = add a spec file, list it here, add its renderer (client) or handler (server).
// Registry tests fail if a spec has no renderer/handler.
export const TOOL_SPECS: readonly ToolSpec[] = [
  infoCard,
  choiceCard,
  speakingTask,
  practiceQuestions,
  remember,
  saveWord,
  openTabTool,
];

export const CLIENT_TOOLS = TOOL_SPECS.filter((s) => s.execution === 'client');
export const SERVER_TOOLS = TOOL_SPECS.filter((s) => s.execution === 'server');

export function getToolSpec(name: string): ToolSpec | undefined {
  return TOOL_SPECS.find((s) => s.name === name);
}

export function functionDeclarations(): FunctionDeclaration[] {
  return TOOL_SPECS.map(toFunctionDeclaration);
}

export type { FunctionDeclaration, ToolSpec };
export { choiceCard, infoCard, practiceQuestions, remember, saveWord, speakingTask };
